import { render } from "./DocumentAnnotations.vue?vue&type=template&id=5e0eb750&scoped=true"
import script from "./DocumentAnnotations.vue?vue&type=script&lang=js"
export * from "./DocumentAnnotations.vue?vue&type=script&lang=js"

import "../../assets/scss/document_annotations.scss?vue&type=style&index=0&id=5e0eb750&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0eb750"]])

export default __exports__